import React from 'react';
import PropTypes from 'prop-types';

import './Card.scss';

const Card = ({ children, title, scroll = false }) => (
  <div className='card card--white'>
    <div className={scroll ? 'card__inner' : ''}>
      {title && <h3 className='card__title' >{title}</h3>}
      {children}
    </div>
  </div>
);

Card.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  scroll: PropTypes.bool
};

export default Card;
